import { RouteComponentProps } from '@reach/router'
import MessageBar from 'assets/theme/components/MessageBar'
import { RootState } from 'context'
import useFirstLogin from 'hooks/useFirstLogin'
import useGetPath from 'hooks/useGetPath'
import React, { useEffect } from 'react'
import { useOnlineStatus } from 'utils'
import encrypt from '../utils/encrypt'
import useIsMobile from '../hooks/useIsMobile';
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from '../interfaces/app/index';
import { setAlert } from 'context/reducer/app'
import Header from 'components/header'
const ProblemsPage = React.lazy(() => import('components/problemPage'))

interface Props {
  flujo: string
}

const Container: React.FC<RouteComponentProps<Props>> = (props) => {
  const { isMobile, problem, alert } = useSelector<RootState, AppState>((state) => state.app)
  const dispatch = useDispatch()
  // Verifica si el usuario tiene conexión a internet
  useOnlineStatus()
  // Revisa el flujo y el reload
  useFirstLogin(props.flujo as string)
  
  useIsMobile()
  useGetPath({
    flujo: props.flujo as string,
    pathname: props.location!.pathname,
  })


  useEffect(() => {
    const clickLogin = async (e: any) => {
      const obj = {
        cellphone: encrypt(e.detail.phone),
        code: problem.code,
        comment: e.detail.comments,
        email: encrypt(e.detail.email),
        experience: e.detail.emoticon,
        identification: encrypt(e.detail.identification),
        type: props.location!.pathname,
        reference: 'FRONTEND-LOGIN',
      }
      fetch(`${process.env.REACT_APP_URL_UTIL}/insert`, {
        body: JSON.stringify(obj),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        mode: 'cors',
      }).then((response) => response.json())
    }
    document.addEventListener('eventClickSendFeedBack', clickLogin)
    return () =>
      document.removeEventListener('eventClickSendFeedBack', clickLogin)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [problem])
  return (
    <div className="App">
      <MessageBar
        adjustin={false}
        text={alert.text}
        status={alert.status}
        autoClose={alert.autoClose}
        open={alert.open}
        setOpen={(estado) =>
          dispatch(setAlert({
            status: alert.status,
            open: estado,
            text: alert.text,
        }))
        }
      />
      <pichincha-feedback is-mobile={isMobile} />
      {problem.open ? (
        <>
        <Header />
        <ProblemsPage
          code={problem.code}
          message={problem.message}
        />
        </>
      ) : (
        props.children
      )}
    </div>
  )
}

export default Container
